import PropTypes from "prop-types";

export const UsersIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M7.933 9.332a1.544 1.544 0 00-.278 0A3.7 3.7 0 014.063 5.64c0-2.042 1.666-3.7 3.735-3.7 2.061 0 3.735 1.658 3.735 3.7a3.712 3.712 0 01-3.6 3.692zM14.031 3.607c1.632 0 2.944 1.308 2.944 2.916 0 1.575-1.262 2.859-2.835 2.917a.958.958 0 00-.218 0M3.727 12.407c-2.036 1.35-2.036 3.55 0 4.892 2.313 1.533 6.107 1.533 8.42 0 2.035-1.35 2.035-3.55 0-4.892-2.305-1.525-6.098-1.525-8.42 0zM15.655 16.94a4.088 4.088 0 001.648-.725c1.312-.975 1.312-2.583 0-3.558-.463-.35-1.026-.584-1.623-.717"></path>
    </svg>
  );
};

UsersIcon.propTypes = {
  active: PropTypes.bool
};
